import { InjectionToken } from '@angular/core';

export const VASS_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('VASS_MOCK_API_DEFAULT_DELAY');
